// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3BXZV","requiredAsterisk":"Info_requiredAsterisk__2uEGT"};